import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';

import List from '../List';
import Dropdown from '../Dropdown';
import Link from '../Link';
import SvgIcon from '../SvgIcon';

import { sectionClicked } from '../../lib/constants';
import { makeTwitterShareUrl, makeFacebookShareUrl, makeWhatsappShareUrl, makeTelegramShareUrl } from '../../lib/social';

import './ShareMenu.scss';

class ShareMenu extends Component {
  static defaultProps = {
    variant: 'default'
  }
  render() {
    const {
      t,
      title,
      href,
      align,
      onClick,
      onCustomClick,
      viewport,
      showIconOnly,
      parentClassName,
      variant,
      isRtl,
      whatsAppDisplayText,
      twitterDisplayText,
      facebookDisplayText,
      telegramDisplayText,
      shareText,
      csfTitle,
      theme,
      noIcon,
      onShareClick
    } =this.props;
    
    return (
      <Dropdown
        align={align}
        isRtl={isRtl}
        toggleEl={<Link onClick={()=> onShareClick ? onShareClick() : ''} theme={theme}>
            {!noIcon && <SvgIcon name="share" title={variant === 'rp' ? shareText : t('SvgTitle.share')} size="m" pushRight isRtl={isRtl}/>}
            {showIconOnly ? null : ( csfTitle ?  csfTitle  : t("global.share", 1))}
            </Link>}
      >
        <List nowrap alignRight={isRtl}>
          <Link fullWidth
            noSitelLocale={true}
            href={makeWhatsappShareUrl(href, viewport)}
            shouldOpenNewPage={true}
            parentClassName={parentClassName}
            title={t('global.whatsapp')}
            onClick={onCustomClick ? ()=>onCustomClick(sectionClicked.shareWhatsapp) : onClick ? () => onClick(variant=== 'default' ? sectionClicked.shareWhatsapp : 0) : null}>
            <SvgIcon name={"whatsapp"} size="m" pushRight={!isRtl} pushLeft={isRtl}/> {whatsAppDisplayText ? whatsAppDisplayText : t('global.whatsapp')}
          </Link>
          <Link fullWidth
            noSitelLocale={true}
            href={makeTwitterShareUrl(href, encodeURIComponent(title))}
            shouldOpenNewPage={true}
            parentClassName={parentClassName}
            title={t('global.twitter')}
            onClick={onCustomClick ? ()=>onCustomClick(sectionClicked.shareTwitter) : onClick ? () => onClick(variant=== 'default' ? sectionClicked.shareTwitter : 1) : null}>
            <SvgIcon name={"twitter"} size="m" pushRight={!isRtl} pushLeft={isRtl}/> {twitterDisplayText ? twitterDisplayText : t('global.twitter')}
          </Link>
          <Link fullWidth
            noSitelLocale={true}
            href={makeFacebookShareUrl(href)}
            shouldOpenNewPage={true}
            parentClassName={parentClassName}
            title={t('global.facebook')}
            onClick={onCustomClick ? ()=>onCustomClick(sectionClicked.shareFacebook) : onClick ? () => onClick(variant=== 'default' ? sectionClicked.shareFacebook: 2) : null}>
            <SvgIcon name={"facebook"} size="m" pushRight={!isRtl} pushLeft={isRtl}/> {facebookDisplayText ? facebookDisplayText : t('global.facebook')}
          </Link>
          <Link fullWidth
          noSitelLocale={true}
          href={makeTelegramShareUrl(href, title)}
          shouldOpenNewPage
          parentClassName={parentClassName}
          title={t('global.telegram')}
          onClick={onCustomClick ? ()=>onCustomClick(sectionClicked.shareTelegram) : onClick ? () => onClick(variant=== 'default' ? sectionClicked.shareTelegram: 3) : null}>
            <SvgIcon name='telegramReal' size="m" pushRight={!isRtl} pushLeft={isRtl}/> {telegramDisplayText ? telegramDisplayText : t('global.telegram')}
          </Link>
        </List>
      </Dropdown>
    );
  }
}

ShareMenu.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  align: PropTypes.shape(Dropdown.propTypes.align),
  viewport: PropTypes.object.isRequired
};

export default translate()(ShareMenu);


// WEBPACK FOOTER //
// ./src/components/ShareMenu/ShareMenu.jsx